import { use } from 'react'

import { AuthContext } from './AuthProvider'

export const useAuth = () => use(AuthContext)
